(function(window, mL, mL_errors, mL_events, mL_config) {
    "use strict";

    var key = '4cite';


    if (mL_config.do_not_track || !mL_config.tags || !mL_config.tags.fc) return;

    window._svq = window._svq || [];

    function get_cart_skus(items) {
        var skus = [],
            i = 0,
            l = items.length;

        for (i; i < l; i += 1) {
            skus.push(items[i].itemid);
        }

        return skus;
    }


    mL_events.subscribe('page', function(msg, data) {
        //console.log('pubsub ' + key + ' - ' + msg, data);
        var cart_items;

        if (msg === 'page.item') {
            _svq.push(['_setContext', '"productid":"' + data.item.sku + '"']);

            if (mL_config.DEBUG) console.log(key + ' - ' + msg, data.item.sku);

        } else if (msg === 'page.category') {
            _svq.push(['_setContext', '"productcat":"' + data.category.name + '"']);

            if (mL_config.DEBUG) console.log(key + ' - ' + msg, data.category.name );

        } else if (msg === 'page.cart') {
            cart_items = get_cart_skus(data.cart.items);
            _svq.push(['_setIsCart', 'true']);
            _svq.push(['_setCartProduct', cart_items]);
            if (mL_config.DEBUG) console.log(key + ' - ' + msg, { cart_items: cart_items });
        }

        _svq.push(['_trackPageView']);


    });

    mL_events.subscribe('form', function(msg, obj) {
        if (!obj.data || !obj.data.email) return;

        _svq.push(['_setEm', obj.data.email]);
        _svq.push(['_trackPageView']);

        if (mL_config.DEBUG) console.log(key + ' - ' + msg, obj.data.email);
    });

    mL_events.subscribe('order.pageview', function(msg, data) {
        var _url = data.url;

        if (_url.indexOf('confirmation') === -1) return;

        _svq.push(['_trackPageView']);

        if (mL_config.DEBUG) console.log(key + ' - ' + msg + ' - data', _url);

    });

    mL_events.subscribe('order.confirmation', function(msg, data) {
        var _order = data.order;

        if (!data.is_dev) {
            _svq.push(['_setIsPurch', 'true']);
            _svq.push(['_setPurchID', _order.order_id]);
            _svq.push(['_setPurchDollar', _order.revenue]);
            _svq.push(['_setPurchProduct', _order.skus]);
            _svq.push(['_trackPageView']);
        }

        if (mL_config.DEBUG) console.log(key + ' - ' + msg);
    });


    mL.fc = mL.fc || {};

    mL.fc.init = function() {
        if (mL.fc.is_init || !mL.add_tracker || !window._svq) return false;

        _svq.push(['_setAccount', '1183_03587']);

        if (!mL.is_checkout && !mL.is_app) _svq.push(['_trackPageView', true]);

        mL.add_tracker('https://track.securedvisit.com/js/sv.js', '4cite');

        mL.fc.is_init = true;

        if (mL_config.DEBUG) console.log(key + ' - plugin loaded');
    };

}(window, window.mL, window.mL_errors, window.mL_events, window.mL_config));